<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="IntegrateHistory">
            <g id="Group">
                <g id="Group_2">
                    <path id="Vector" d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM12 8C11.4477 8 11 8.44772 11 9V12C11 12.3747 11.206 12.7012 11.511 12.8725L11.6313 12.933L14.2448 14.4421C14.7231 14.7182 15.3347 14.5543 15.6109 14.076C15.887 13.5978 15.7231 12.9862 15.2448 12.71L13 11.414V9C13 8.44772 12.5523 8 12 8Z" fill="#8993A4"/>
                </g>
            </g>
        </g>
    </svg>
</template>
